export default __webpack_public_path__ + "static/media/left.791f2bd5.svg";